<template>
  <div class="wrap">

    <!-- browser-suggestion -->
    <browser-suggestion></browser-suggestion>
    <!-- browser-suggestion -->

    <div class="wrapper">
      <div class="form-title">
        <form-title :tip="tip" :flag="flag" :tip3="tip3"></form-title>
      </div>
      <div class="reg-form">

        <div class="edit-form-wrap" >
          <el-form
            :model="regForm"
            :rules="rules"
            ref="regForm"
            label-width="80px"
            class="form"
          >
            <el-form-item label="用户名" prop="username">
              <el-input
                v-model="regForm.username"
                placeholder="请填写您的用户名"
                clearable
                autoComplete="off"
              />
            </el-form-item>
            <el-form-item label="姓名" prop="name">
              <el-input
                v-model="regForm.name"
                placeholder="请填写您的真实有效姓名"
                clearable
                autoComplete="off"
              />
            </el-form-item>

            <el-form-item label="身份证" prop="idNum">
              <el-input
                v-model="regForm.idNum"
                placeholder="请填写您的真实身份证"
                clearable
                autoComplete="off"
              />
            </el-form-item>


            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="regForm.sex" autoComplete="off" >
                <el-radio label="男"></el-radio>
                <el-radio label="女"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input
                v-model="regForm.email"
                placeholder="请输入您的电子邮箱地址接收信息"
                clearable
                autoComplete="off"
              />
            </el-form-item>

            <el-form-item label="手机号" prop="telphone">
              <el-input
                v-model="regForm.telphone"
                placeholder="请输入手机号"
                clearable
                autoComplete="off"
              />
            </el-form-item>

            <el-form-item label="登录密码" prop="password">
              <el-input
                type="password"
                v-model="regForm.password"
                placeholder="密码长度在6-20位字符之间"
                autoComplete="off"
              />
            </el-form-item>
            <el-form-item label="确认密码" prop="password2">
              <el-input
                type="password"
                v-model="regForm.password2"
                placeholder="请重新输入登录密码"
                autoComplete="off"
              />
            </el-form-item>

            <div class="form-opts" >
              <el-button :loading="isRequest" type="primary" @click="submit('regForm')">
                注册完成返回登录页
              </el-button>
              <el-button @click="resetForm('regForm')" type="info">
                重置
              </el-button>
            </div>

          </el-form>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import formTitle from '../common/formTitle';
import { regUser } from '../request/regAndEdit';
import { Message } from 'element-ui';
import BrowserSuggestion from '../common/BrowserSuggestion';
import { ValidateFormIdNum, ValidateFormPhone, ValidateFormEmail } from '../../utils/tools';




export default {
  name: 'register',
  components: {
    formTitle,
    BrowserSuggestion
  },
  data() {


    //密码验证
    let checkPassword = (rule, value, callback) => {
      
      // 是否包含一位数字
      // const regNumber = /(?=.*[\d])/
      // // 是否包含一位字母
      // const regLetter = /(?=.*[a-zA-Z])/
      // // 是否包含一位特殊字符
      // const regCharacter = /[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/
      if (!value || value == '') {
        callback(new Error('密码不能为空!'));
        return;
      } 
      if (value.length > 20 || value.length < 6) {
          callback(new Error('密码长度为6-20位!'));
          return;
      }

      // if (!regNumber.test(value)) {
      //   callback(new Error('密码必须由数字，英文字母和特殊字符组成!'));
      //   return;
      // }

      // if (!regLetter.test(value)) {
      //   callback(new Error('密码必须由数字，英文字母和特殊字符组成!'));
      //   return;
      // }

      // if (!regCharacter.test(value)) {
      //   callback(new Error('密码必须由数字，英文字母和特殊字符组成!'));
      //   return;
      // }

      callback()

    }
    
    //确认密码
    let checkPassword2 = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('请重复输入密码'));
        return;
      }  
      if (value !== this.regForm.password) {
        callback(new Error('两次输入密码不一致'));
        return;
      }
      callback()
    }


    return {
      isRequest: false,
      regForm: {
        username: '',
        name: '',
        credtype: '身份证',
        idNum: '',
        sex: '',
        email: '',
        telphone: '',
        password: '',
        password2: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入字母或数字', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入中文或字母', trigger: 'blur' }
        ],
        credtype: [
          { required: true, message: '请选择证件类型', trigger: 'change' }
        ],
        idNum: [{ required: true, validator: ValidateFormIdNum, trigger: 'blur' }],
        sex: [{ required: true, message: '请选择您的性别', trigger: 'change' }],
        email: [{ required: true, validator: ValidateFormEmail, trigger: 'blur' }],
        telphone: [{ required: true, validator: ValidateFormPhone, trigger: 'blur' }],
        password: [
          { required: true, validator: checkPassword, trigger: 'blur' }
        ],
        password2: [
          { required: true, validator: checkPassword2, trigger: 'blur' }
        ]
      },
      tip: '快速注册',
      tip3: '温馨提示：注册完成后，用户名用于登录且不能修改；姓名、身份证将用于简历投递，可在注册信息中修改。',
      flag: true
    }
  },
  mounted() {},

  methods: {
    //注册完成提交
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.regUser()
        } else {
          return false
        }
      })
    },
    //数据请求
    regUser() {
      let params = {
        name: this.regForm.name,
        credtype: '身份证',
        id: this.regForm.idNum,
        sex: this.regForm.sex,
        email: this.regForm.email,
        pwd: this.regForm.password,
        username: this.regForm.username,
        telphone: this.regForm.telphone
      }
      // console.log(params);
      regUser(params).then(res => {
        if (res.success) {
          this.$message.success({
            message: res.message,
              type: 'success',
              duration: 1000,
              onClose: () => {
                this.$router.push({ 'name': 'login' });
              }
          });
        } else {
          Message({
              message: res.message,
              type: 'warning',
              duration: 5 * 1000
          });
        }
      })
    },
    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>



.wrap {

  .wrapper {
    width: auto;
    margin: 0 auto;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 24px;
    padding-bottom: 40px;
  }

  .form-title-wrap {
    line-height: 40px;
    margin-bottom: 12px;
  }

  .reg-form {
    margin: 0 auto;
    background: #fff;
    border-radius: 4px;
    padding: 12px;
  }

  .edit-form-wrap {
      margin: 0 auto;
  }

  .form-opts {
    text-align: center;
  }


}



@media screen and (min-width: 320px) { 

}

@media screen and (min-width: 480px) { 
    
}
/* 移动 */
@media screen and (min-width: 576px) { 
    
}
/* 平板 */
@media screen and (min-width: 768px) { 

}

/* PC */
@media screen and (min-width: 992px) {

}
@media screen and (min-width: 1200px) {

  .wrap {

    .wrapper {
      width: 1200px;
      padding-left: 0;
      padding-right: 0;
    }


  }

}





</style>
